module.exports = __webpack_public_path__ + "static/media/outline-format_indent_decrease-24px.6d5d67e7.svg";